require('./errorListDetailed.less');
import {statuses} from "../errorList.ts";

class ErrorListDetailedController {
    transactions;

    tableDefinition = {
        settings: {title: 'Transaksjonsdetaljer', backFunction: () => window.history.back(), promise: null, hidePaginator: true},
        columns:[
            {title:'Varenummer', name: 'itemNo'},
            {title:'Fra lokasjon', name:'locationFrom'},
            {title:'Til lokasjon', name:'locationTo'},
            {title:'Antall', name:'quantity', type:'number'},
            {title:'Meldingstekst', name:'message'},
            {title:'Status', name:'status', outputDef:statuses}
        ]
    };

    constructor(private toastService, private Erp, private $stateParams){  }

    $onInit() {
        this.tableDefinition.settings.promise = this.Erp.getTransactions({id: this.$stateParams.id}).$promise.then((result)=> {
            this.transactions = result;
        }, (error) => {
            this.toastService.parseError(error);
        });
    }
}

class ErrorListDetailedOptions implements ng.IComponentOptions {
    controllerAs =  'c';
    public controller:string = "rkcErrorListDetailedController";
    public template: any = require('./errorListDetailed.html');
}

rkcApp.controller("rkcErrorListDetailedController", ['toastService', 'Erp', '$stateParams', function(toastService, Erp, $stateParams){
    return new ErrorListDetailedController(toastService, Erp, $stateParams);
}])
    .component("rkcErrorListDetailed", new ErrorListDetailedOptions());


/** WEBPACK FOOTER **
 ** ./src/app/components/main/views/errorList/errorListDetailed/errorListDetailed.ts
 **/